var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplayBanner)?_c('cmg-loyalty-sign-in-banner',{attrs:{"loyaltyBanner":_vm.rewardsBannerData}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }